import { createFileRoute } from "@tanstack/react-router";
import Topics from "@/pages/Topics";

export const Route = createFileRoute("/_app/topics/")({
  component: () => (
    <Topics />
  ),
});
